import { Schema } from "rsuite";

const { StringType, ArrayType, NumberType, DateType } = Schema.Types;

export const CaregiverFormSchema = Schema.Model({
  DateOfBirth: DateType(),
  UserName: StringType()
    .maxLength(64)
    .minLength(3)
    .isRequired("UserName is required"),
  FirstName: StringType().maxLength(30).isRequired("FirstName is required"),
  Gender: StringType().isRequired("Gender is required"),
  LastName: StringType().maxLength(30).isRequired("LastName is required"),
  PhoneNumber: StringType().maxLength(20).isRequired("PhoneNumber is required"),
  ProfilePic: ArrayType("Please select valid files").minLength(1),
  Rate: NumberType().isRequired("Rate is required"),
  email: StringType()
    .isEmail("Must be a valid email")
    .maxLength(50)
    .isRequired("email is required"),
  SSN: StringType().maxLength(50).isRequired("SSN is required"),
  ChampsIdNo: StringType().maxLength(50).isRequired("ChampsIdN is required"),
  Certificates: ArrayType("Please select valid files"),
  Address: StringType().maxLength(200),
  Languages: ArrayType(),
  AvailableFrom: DateType(),
  AvailableTo: DateType(),
  Password: StringType().maxLength(200),
  ApartmentNumber: StringType().maxLength(50),
});
